module.exports = __webpack_public_path__ + "../front/img/468_dobbelt_bøjestang.9e849899.svg";